import { axiosInstance } from '../api';

export default function(title) {
    return axiosInstance.get(`/fhir/Questionnaire/${title}`);
}